/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommContentTemplate3Data } from './ecomm-content-template-3.data';
import { IEcommContentTemplate3Props } from './ecomm-content-template-3.props.autogenerated';

export interface IEcommContentTemplate3ViewProps extends IEcommContentTemplate3Props<IEcommContentTemplate3Data> {
    firstImage: MsDyn365.IImageData;
    secondImage: MsDyn365.IImageData;
    thirdImage: MsDyn365.IImageData;
    anchorID: string;
    TemplateContainerStyle: any;
    ImageContainerStyle: any;
    NoImage: any;
}

/**
 *
 * EcommContentTemplate3 component
 * @extends {React.PureComponent<IEcommContentTemplate3Props<IEcommContentTemplate3Data>>}
 */
class EcommContentTemplate3 extends React.PureComponent<IEcommContentTemplate3Props<IEcommContentTemplate3Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const EcommContentTemplateViewProps = {
            ...this.props,
            firstImage: config.firstImage,
            secondImage: config.secondImage,
            thirdImage: config.thirdImage,
            anchorID: config.anchorID,
            TemplateContainerStyle: {
                className: 'ecomm-content-template-3'
            },
            ImageContainerStyle: {
                className: 'img-container'
            },
            NoImage: {
                className: 'msc-empty_image'
            }
        };

        return this.props.renderView(EcommContentTemplateViewProps);
    }
}

export default EcommContentTemplate3;
